import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom'; // Adicionado Outlet
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './assets/styles/base/variables.css';
import Dashboard from './pages/Dashboard/Dashboard';
import Login from "./components/Login/Login";
import AdminUsuarios from "./pages/Admin/AdminUsuarios";
import AtivarConta from "./components/Login/AtivarConta";
import { AuthProvider } from './utils/useAuthContext';
import AcessoRapido from "./components/Login/AcessoRapido";
import ModuleRoute from './components/Login/ModuleRoute';

// Importação de Estilos
import containerStyles from './components/Layout/container.module.css'; // Adicionado import de estilos

import MainLayout from './components/Layout/MainLayout';
import AgroLayout from './components/Layout/AgroLayout';

// Páginas de Pescadores
import Pescadores from './pages/Pescadores/Pescadores';
import PescadoresList from './pages/Pescadores/PescadoresList';
import PescadorView from './pages/Pescadores/PescadorView';
import MatrizPescadores from './pages/Pescadores/MatrizPescadores';
import ImportarFichaCampo from './pages/Pescadores/ImportarFichaCampo';
import ProjetosList from './pages/Projetos/ProjetosList';
import LocaisList from './pages/Locais/LocaisList';
import PendenciasLocais from './pages/Locais/PendenciasLocais';
import MapaLocais from './pages/Locais/MapaLocais';
import GeografiaLayout from './pages/Locais/GeografiaLayout';
import ImportarGeometria from './pages/Locais/ImportarGeometria';
import ColoniasList from './pages/Colonias/ColoniasList';
import EspeciesList from './pages/Especies/EspeciesList';
import EspeciesLayout from './pages/Especies/EspeciesLayout';
import EspeciePendencias from './pages/Especies/EspeciePendencias';
import CatalogoProjetoEspecies from './pages/Especies/CatalogoProjetoEspecies';
import ArtesList from './pages/Artes/ArtesList';
import AreasList from './pages/Areas/AreasList';
import UsuariosList from './pages/Usuarios/UsuariosList';
// import MensagemHistoricoView from './pages/Mensagens/MensagemHistoricoView';
import MensagensPage from './pages/Mensagens/MensagensPage';
import ChatSyncorpPage from './pages/ChatSyncorp/ChatSyncorpPage';
import TemplatesPage from './pages/Templates/TemplatesPage';
import Galeria from './pages/Galeria/Galeria';

// Páginas de Registros de Pesca (Adicione estas importações)
import RegistrosList from './pages/Registros/RegistrosList';
import RegistroView from './pages/Registros/RegistroView';
import AValidar from './pages/Registros/AValidar';

// Agro (NOVO)
import AgroDashboard from './pages/Agro/Dashboard/AgroDashboard';
import AgroFinanceiro from './pages/Agro/Financeiro/AgroFinanceiro';
import AgroKanban from './pages/Agro/Kanban/AgroKanban';
import AgroEventosList from './pages/Agro/Eventos/AgroEventosList';
import AgroEventoView from './pages/Agro/Eventos/AgroEventoView';
import AgroFazenda from './pages/Agro/Fazenda/AgroFazenda';
import FinancialHub from './pages/Agro/Financial/FinancialHub';
import ChartOfAccounts from './pages/Agro/Financial/ChartOfAccounts/ChartOfAccounts';
import CostCenter from './pages/Agro/Financial/CostCenters/CostCenters';
import FinancialAccounts from './pages/Agro/Financial/FinancialAccounts/FinancialAccounts';
import IncomingPayments from './pages/Agro/Financial/AccountsReceivable/IncomingPayments';
import IncomingPaymentsAdd from './pages/Agro/Financial/AccountsReceivable/IncomingPaymentsAdd';
import Expenses from './pages/Agro/Financial/AccountsPayable/Expenses';
import ExpensesAdd from './pages/Agro/Financial/AccountsPayable/ExpensesAdd';
import CashFlow from './pages/Agro/Financial/CashFlow/CashFlow';
import Customers from './pages/Agro/Customers/Customers';
import AddCustomer from './pages/Agro/Customers/EntityCustomers/AddCustomer';
import Suppliers from './pages/Agro/Suppliers/Suppliers';
import EntitySupplier from './pages/Agro/Suppliers/EntitySupplier/EntitySupplier';
import ProductsHub from './pages/Agro/Products/ProductsHub';
import Products from './pages/Agro/Products/Products/Products';
import ProductsAdd from './pages/Agro/Products/Products/ProductsAdd';
import CategoriesProducts from './pages/Agro/Products/Products/CategoriesProducts/CategoriesProducts';
import CashFlowForm from './pages/Agro/Financial/CashFlow/CashFlowForm';

// ─── super adm ──────────────────────────────
import AdminRoute from './components/Login/AdminRoute';
import AdminLayout from './components/Layout/AdminLayout';
import AdminDashboard from './pages/SuperAdmin/AdminDashboard';
import AdminUsuarios2 from './pages/SuperAdmin/AdminUsuarios';
import AdminPendentes from './pages/SuperAdmin/AdminPendentes';
import AdminFazendas from './pages/SuperAdmin/AdminFazendas';
import AdminWhatsapp from './pages/SuperAdmin/AdminWhatsapp';

// ─── Guards ───────────────────────────────────────────────────────────────────

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const token = localStorage.getItem("inteagro_token");
  return token ? <>{children}</> : <Navigate to="/" />;
};

// Redireciona para o módulo correto após login
const ModuleRedirect = () => {
  const modulo = localStorage.getItem("modulo") || "agro";
  if (modulo === "admin") return <Navigate to="/superadmin/dashboard" />;
  if (modulo === "pesca") return <Navigate to="/admin/dashboard" />;
  return <Navigate to="/agro/dashboard" />;
};

/* const AdminHome = () => {
  return (
    <div style={{ padding: 24 }}>
      <h1>Admin</h1>
      <p>Ambiente administrativo do Inteagro</p>
      <AdminUsuarios />
    </div>
  );
}; */

// ─── App ──────────────────────────────────────────────────────────────────────

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Públicas */}
          <Route path="/" element={<Login />} />
          <Route path="/ativar-conta" element={<AtivarConta />} />
          <Route path="/acesso/:token" element={<AcessoRapido />} /> {/* NOVO — link seguro */}

          {/* Redirect pós-login */}
          <Route path="/redirect" element={<PrivateRoute><ModuleRedirect /></PrivateRoute>} />

          {/* ── Módulo AGRO ─────────────────────────────────────────── */}
          <Route path="/agro" element={<ModuleRoute moduloRequerido="agro"><AgroLayout /></ModuleRoute>}>
            <Route index element={<Navigate to="dashboard" />} />
            <Route path="dashboard" element={<AgroDashboard />} />
            <Route path="financeiro" element={<AgroFinanceiro />} />
            <Route path="kanban" element={<AgroKanban />} />
            <Route path="eventos" element={<AgroEventosList />} />
            <Route path="eventos/:uid" element={<AgroEventoView />} />
            <Route path="fazenda" element={<AgroFazenda />} />

            <Route path="financialHub">
              <Route index element={<FinancialHub />} />
              <Route path="chartOfAccounts" element={<ChartOfAccounts />} />
              <Route path="costCenters" element={<CostCenter />} />
              <Route path="financialAccounts" element={<FinancialAccounts />} />
              <Route path="accountsReceivable">
                <Route index element={<IncomingPayments />} />
                <Route path='add' element={<IncomingPaymentsAdd />} />
                <Route path='edit/:uid' element={<IncomingPaymentsAdd />} />
              </Route>
              <Route path="accountsPayable">
                <Route index element={<Expenses />} />
                <Route path='add' element={<ExpensesAdd />} />
                <Route path='edit/:uid' element={<ExpensesAdd />} />
              </Route>
              <Route path="cashFlow">
                <Route index element={<CashFlow />} />
                <Route path='add' element={<CashFlowForm />} />
                <Route path='edit/:uid' element={<CashFlowForm />} />
              </Route>
            </Route>

            <Route path="customers">
              <Route index element={<Customers />} />
              <Route path='add' element={<AddCustomer />} />
              <Route path='edit/:uid' element={<AddCustomer />} />
            </Route>

            <Route path="suppliers">
              <Route index element={<Suppliers />} />
              <Route path='add' element={<EntitySupplier />} />
              <Route path='edit/:uid' element={<EntitySupplier />} />
            </Route>

            <Route path="productsHub">
              <Route index element={<ProductsHub />} />
              <Route path="products">
                <Route index element={<Products />} />
                <Route path='add' element={<ProductsAdd />} />
                <Route path='edit/:uid' element={<ProductsAdd />} />
              </Route>
              <Route path="category" element={<CategoriesProducts />} />
            </Route>


          </Route>

          {/* ── Módulo PESCA / ADMIN (existente) ────────────────────── */}
          <Route path="/admin" element={<ModuleRoute moduloRequerido="pesca"><MainLayout /></ModuleRoute>}>
            <Route index element={<Navigate to="dashboard" />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="pescadores" element={<Pescadores />}>
              <Route index element={<PescadoresList />} />
              <Route path="matriz" element={<MatrizPescadores />} />
              <Route path="view/:uid" element={<PescadorView />} />
              <Route path="view/:uid/importar-ficha" element={<ImportarFichaCampo />} />
              <Route path="add" element={<div>Formulário de Adicionar</div>} />
            </Route>
            <Route
              path="registros"
              element={<div className={containerStyles.containerPage} style={{ paddingLeft: 0 }}><Outlet /></div>}
            >
              <Route index element={<RegistrosList />} />
              <Route path="view/:uid" element={<RegistroView />} />
              <Route path="add" element={<div>Nova Pescaria</div>} />
              <Route path="validar" element={<AValidar />} />
            </Route>
            <Route path="mensagens" element={<MensagensPage />} />
            <Route path="chat-syncorp" element={<ChatSyncorpPage />} />
            <Route path="projetos" element={<ProjetosList />} />
            {/* Geografia (Mapa de Pesca / Locais de Pesca / Pendências de
                Local / Áreas de Pesca) — 1 item só no sidebar, abas no topo
                pra trocar entre elas. URLs de cada tela continuam as mesmas
                de antes (a casca é só um layout por cima, via Outlet). */}
            <Route element={<GeografiaLayout />}>
              <Route path="locais" element={<LocaisList />} />
              <Route path="locais/pendencias" element={<PendenciasLocais />} />
              <Route path="locais/mapa" element={<MapaLocais />} />
              <Route path="locais/importar-geometria" element={<ImportarGeometria />} />
              <Route path="areas" element={<AreasList />} />
            </Route>
            <Route path="usuarios" element={<UsuariosList />} />
            <Route path="templates" element={<TemplatesPage />} />
            <Route path="galeria" element={<Galeria />} />
            <Route path="colonias" element={<ColoniasList />} />
            {/* Espécies (SYNCORP-912) — mesmo padrão do GeografiaLayout:
                1 item no sidebar, abas no topo pra Espécies/Pendências/
                Catálogo por Projeto. */}
            <Route element={<EspeciesLayout />}>
              <Route path="especies" element={<EspeciesList />} />
              <Route path="especies/pendencias" element={<EspeciePendencias />} />
              <Route path="especies/catalogo" element={<CatalogoProjetoEspecies />} />
            </Route>
            <Route path="artes" element={<ArtesList />} />
          </Route>

          {/* ── Super adm ──────── */}
          <Route
            path="/superadmin"
            element={
              <AdminRoute>
                <AdminLayout />
              </AdminRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="usuarios" element={<AdminUsuarios2 />} />
            <Route path="pendentes" element={<AdminPendentes />} />
            <Route path="fazendas" element={<AdminFazendas />} />
            <Route path="whatsapp" element={<AdminWhatsapp />} />
          </Route>

          {/* Catch-all — deve ser SEMPRE o último */}
          <Route path="*" element={<Navigate to="/" />} />
          


      </Routes>
      <ToastContainer position="bottom-center" autoClose={3000} theme="colored" />
    </AuthProvider>
    </Router >
  );
}

export default App;